import { Dialog } from "primereact/dialog";
import { TECI } from "./modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Fetch } from "../../utilities/fetch";

interface Iprops {
    data?: TECI,
    open: boolean,
    hideDialog: () => void
}

interface IHistory {
    ecI_Date_Time: string;
    timeZoneId: number;
    timeZone: string;
    interviewrName?: string;
    client?: string;
    interviewProcessId: number;
    interviewProcess: string;
    statusId: number;
    statusName: string;
    createdOn: string;
    createdBy: string;
    comment?: string;
}

export const ECIHistory = (props: Iprops) => {
    const [history, setHistory] = useState<{ data: IHistory[], loading: boolean }>({ data: [], loading: false });

    const onHide = () => {
        props.hideDialog();
    }

    async function loadHistory(eciId: number) {
        setHistory({ data: [], loading: true });
        const data = await Fetch<IHistory[]>(`eci/history/${eciId}`);
        if (data) {
            setHistory({ data: data, loading: false });
        }
        else setHistory({ data: [], loading: false });
    }

    useEffect(() => {
        if (props.open && props.data?.id) {
            loadHistory(props.data.id);
        }
    }, [props.open, props.data?.id]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`ECI Change History for ${props.data?.candidateName}`} modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" value={history.data} loading={history.loading}>
                <Column field="sn" header="S.No" body={(r: IHistory, { rowIndex }: any) => rowIndex + 1} />
                <Column field="statusName" header="Status" />
                <Column field="ecI_Date_Time" header="ECI Date" body={(r: IHistory) => format(new Date(r.ecI_Date_Time + 'z'), "MM-dd-yyyy")} />
                <Column field="ecI_Date_Time" header="Time" body={(r: IHistory) => format(new Date(r.ecI_Date_Time + 'z'), "hh:mm a")} />
                <Column field="timeZone" header="Time Zone" />
                <Column field="interviewProcess" header="Interview Process" />
                <Column field="createdBy" header="Created By" />
                <Column field="createdOn" header="Created On" body={(r: IHistory) => format(new Date(r.createdOn + 'z'), "MM-dd-yyyy hh:mm a")} />
                <Column field="comment" header="Comment" />
            </DataTable>
        </Dialog>
    );
}